import React, {Component} from "react";

import {Table, Button} from "react-bootstrap";
import FaPen from "react-icons/lib/fa/pencil";
import FaTrash from "react-icons/lib/fa/trash";

class GroupsList extends Component {

  render() {
    const listItems = this.props.groups.map(group => {
      return (
        <tr key={"group" + group.id}>
          <td className="groups-table-td-name">{group.name}</td>
          <td className="groups-table-td-button">
            <Button
              bsStyle="primary"
              onClick={() => this.props.onEdit(group.id)}
            >
              <FaPen />
            </Button>
          </td>
          <td className="groups-table-td-button">
            <Button
              bsStyle="danger"
              onClick={() => this.props.onDelete(group.id, group.name)}
            >
              <FaTrash />
            </Button>
          </td>
        </tr>
      );
    });

    return (
      <div className="groups-div-left">
        <Table responsive>
          <thead>
            <tr>
              <th colSpan="3">List of groups</th>
            </tr>
            <tr>
              <th className="groups-table-td-name">Name</th>
              <th className="groups-table-td-button">Update</th>
              <th className="groups-table-td-button">Delete</th>
            </tr>
          </thead>
          <tbody>{listItems}</tbody>
        </Table>
      </div>
    )
  }
}

export default GroupsList;


// WEBPACK FOOTER //
// ./src/components/groups/GroupsList.js